import { Suspense } from 'react';
import { useRecoilValue } from 'recoil';
import { Route, Routes } from 'react-router-dom';
import { meState } from './state.js';
import { Router } from './Router.js';
import { LoginPage } from './pages/LoginPage.js';
import { Layout } from './components/Layout.js';
import { AgioLogoAnimated } from './components/AgioLogoAnimated.js';

function Gate() {
  const me = useRecoilValue(meState);
  if (!me) return <LoginPage />;
  return (
    <Layout>
      <Router />
    </Layout>
  );
}

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <AgioLogoAnimated />
    </div>
  );
}

export function App() {
  return (
    <Suspense fallback={<Splash />}>
      <Routes>
        <Route path="*" element={<Gate />} />
      </Routes>
    </Suspense>
  );
}
